function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("polygon", {
  points: "28.6,50.7 12.8,46.2 12.8,36.8 15.8,36.8 15.8,43.9 25.6,46.7 25.6,40.5 28.6,40.5  "
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M41.4,47.1l-35-10V19.3l35-10V47.1z M9.5,34.8l28.9,8.3V13.3L9.5,21.6V34.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 38.4,
  y: 13.1,
  width: 3,
  height: 30.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M51.9,28.2h-3c0-1.5-1.2-2.7-2.7-2.7v-3C49.3,22.4,51.9,25,51.9,28.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M46.2,33.9v-3c1.5,0,2.7-1.2,2.7-2.7h3C51.9,31.3,49.3,33.9,46.2,33.9z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M59.2,28.2h-3c0-5.5-4.5-10-10-10v-3C53.4,15.2,59.2,21,59.2,28.2z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M46.2,41.2v-3c5.5,0,10-4.5,10-10h3C59.2,35.4,53.4,41.2,46.2,41.2z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M7.1,34.8c-3.7,0-6.6-3-6.6-6.6h3c0,2,1.6,3.6,3.6,3.6V34.8z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M3.5,28.2h-3c0-3.7,3-6.6,6.6-6.6v3C5.1,24.6,3.5,26.2,3.5,28.2z"
}))))));

var SvgSpeaker = function SvgSpeaker(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/speaker.628609bb.svg";
export { SvgSpeaker as ReactComponent };